<template>
  <sui-segment-group style="max-width: 900px; margin: auto" raised>
    <sui-segment inverted style="text-align: center; font-size: 18px">
      <sui-icon name="comments" /> Plantillas de Mensajes WhatsApp
    </sui-segment>

    <!-- Category Tabs -->
    <sui-menu attached="top" tabular>
      <sui-menu-item
        :active="activeTab === 'orders'"
        @click="activeTab = 'orders'"
      >
        <sui-icon name="shopping cart" /> Ordenes
      </sui-menu-item>
      <sui-menu-item
        :active="activeTab === 'purchases'"
        @click="activeTab = 'purchases'"
      >
        <sui-icon name="truck" /> Compras
      </sui-menu-item>
      <sui-menu-item
        :active="activeTab === 'payments'"
        @click="activeTab = 'payments'"
      >
        <sui-icon name="dollar sign" /> Pagos
      </sui-menu-item>
      <sui-menu-item
        :active="activeTab === 'promotional'"
        @click="activeTab = 'promotional'"
      >
        <sui-icon name="bullhorn" /> Promocionales
      </sui-menu-item>
      <sui-menu-item position="right">
        <sui-button primary size="small" @click="openNewTemplate">
          <sui-icon name="plus" /> Nueva Plantilla
        </sui-button>
      </sui-menu-item>
    </sui-menu>

    <!-- Templates Table -->
    <sui-segment attached="bottom" :loading="loading">
      <sui-table striped v-if="filteredTemplates.length > 0">
        <sui-table-header>
          <sui-table-row>
            <sui-table-header-cell>Evento</sui-table-header-cell>
            <sui-table-header-cell>Nombre</sui-table-header-cell>
            <sui-table-header-cell width="2">Estado</sui-table-header-cell>
            <sui-table-header-cell width="3">Acciones</sui-table-header-cell>
          </sui-table-row>
        </sui-table-header>
        <sui-table-body>
          <sui-table-row
            v-for="template in filteredTemplates"
            :key="template.template_id"
          >
            <sui-table-cell>
              <sui-label
                :color="getEventColor(template.event_type)"
                size="small"
              >
                {{ getEventLabel(template.event_type) }}
              </sui-label>
            </sui-table-cell>
            <sui-table-cell>{{ template.template_name }}</sui-table-cell>
            <sui-table-cell>
              <SuiCheckbox
                toggle
                :model-value="template.is_enabled === 1"
                @update:model-value="toggleTemplate(template, $event)"
              />
            </sui-table-cell>
            <sui-table-cell>
              <sui-button size="mini" @click="previewTemplate(template)">
                <sui-icon name="eye" />
              </sui-button>
              <sui-button size="mini" @click="editTemplate(template)">
                <sui-icon name="edit" />
              </sui-button>
              <sui-button
                size="mini"
                color="red"
                @click="confirmDelete(template)"
              >
                <sui-icon name="trash" />
              </sui-button>
            </sui-table-cell>
          </sui-table-row>
        </sui-table-body>
      </sui-table>

      <sui-message v-else info style="text-align: center">
        <sui-icon name="inbox" />
        No hay plantillas en esta categoria
      </sui-message>
    </sui-segment>
  </sui-segment-group>

  <!-- Template Editor Modal -->
  <sui-modal v-model="showEditor" size="large">
    <sui-modal-header>
      {{ editingTemplate ? "Editar Plantilla" : "Nueva Plantilla" }}
    </sui-modal-header>
    <sui-modal-content scrolling>
      <sui-form>
        <sui-form-field v-if="!editingTemplate">
          <label>Tipo de Evento</label>
          <select
            class="ui dropdown"
            v-model="templateForm.event_type"
            @change="loadVariables"
          >
            <option value="">Selecciona un evento</option>
            <option
              v-for="event in eventTypes"
              :key="event.value"
              :value="event.value"
            >
              {{ event.label }}
            </option>
          </select>
        </sui-form-field>

        <sui-form-field>
          <label>Nombre de la Plantilla</label>
          <input
            type="text"
            placeholder="Ej: Confirmacion de orden"
            v-model="templateForm.template_name"
          />
        </sui-form-field>

        <sui-form-field>
          <label>Contenido del Mensaje</label>
          <textarea
            rows="8"
            placeholder="Escribe tu mensaje aqui..."
            v-model="templateForm.template_content"
          ></textarea>
        </sui-form-field>

        <!-- Variables Section -->
        <div class="variables-section" v-if="variables.length > 0">
          <label>Variables Disponibles</label>
          <div class="variable-chips">
            <sui-label
              v-for="variable in variables"
              :key="variable.variable_id"
              as="a"
              @click="insertVariable(variable.variable_name)"
            >
              {{ variable.variable_name }}
              <sui-icon name="plus" />
            </sui-label>
          </div>
          <small class="variable-hint"
            >Haz clic en una variable para insertarla</small
          >
        </div>

        <!-- Preview Section -->
        <div class="preview-section" v-if="templateForm.template_content">
          <label>Vista Previa</label>
          <sui-segment class="preview-box">
            <pre>{{ previewContent }}</pre>
          </sui-segment>
        </div>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button @click="showEditor = false">Cancelar</sui-button>
      <sui-button
        primary
        @click="saveTemplate"
        :class="{ loading: savingTemplate }"
        :disabled="!isFormValid"
      >
        <sui-icon name="save" /> Guardar
      </sui-button>
    </sui-modal-actions>
  </sui-modal>

  <!-- Preview Modal -->
  <sui-modal v-model="showPreview" size="small">
    <sui-modal-header> <sui-icon name="eye" /> Vista Previa </sui-modal-header>
    <sui-modal-content>
      <sui-segment class="preview-box">
        <pre>{{ previewModalContent }}</pre>
      </sui-segment>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button @click="showPreview = false">Cerrar</sui-button>
    </sui-modal-actions>
  </sui-modal>

  <!-- Delete Confirmation Modal -->
  <sui-modal v-model="showDeleteConfirm" size="mini">
    <sui-modal-header>
      <sui-icon name="warning sign" color="red" /> Confirmar Eliminacion
    </sui-modal-header>
    <sui-modal-content>
      <p>
        ¿Estas seguro de eliminar la plantilla "{{
          templateToDelete?.template_name
        }}"?
      </p>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button @click="showDeleteConfirm = false">Cancelar</sui-button>
      <sui-button
        negative
        @click="deleteTemplate"
        :class="{ loading: deleting }"
      >
        <sui-icon name="trash" /> Eliminar
      </sui-button>
    </sui-modal-actions>
  </sui-modal>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useToast } from "vue-toastification";
import { SuiCheckbox } from "vue-fomantic-ui";
import API from "../../api/Api";

const toast = useToast();

// State
const loading = ref(false);
const templates = ref([]);
const activeTab = ref("orders");
const showEditor = ref(false);
const showPreview = ref(false);
const showDeleteConfirm = ref(false);
const editingTemplate = ref(null);
const templateToDelete = ref(null);
const savingTemplate = ref(false);
const deleting = ref(false);
const variables = ref([]);
const eventTypes = ref([]);
const previewModalContent = ref("");

const templateForm = ref({
  event_type: "",
  template_name: "",
  template_content: "",
});

// Event type configuration
const EVENT_CONFIG = {
  order_created: { label: "Orden creada", color: "blue" },
  order_confirmed: { label: "Orden confirmada", color: "teal" },
  order_shipped: { label: "Orden enviada", color: "olive" },
  order_delivered: { label: "Orden entregada", color: "green" },
  order_cancelled: { label: "Orden cancelada", color: "red" },
  payment_due: { label: "Pago proximo", color: "yellow" },
  payment_overdue: { label: "Pago vencido", color: "orange" },
  payment_received: { label: "Pago recibido", color: "green" },
  promotional: { label: "Promocional", color: "purple" },
  purchase_order_sent: { label: "Compra enviada", color: "blue" },
  purchase_order_confirmed: { label: "Compra confirmada", color: "teal" },
  purchase_order_shipped: { label: "Compra en camino", color: "olive" },
  purchase_order_delivered: { label: "Compra recibida", color: "green" },
  purchase_order_cancelled: { label: "Compra cancelada", color: "red" },
};

// Sample data for preview
const SAMPLE_DATA = {
  client_name: "Juan Perez",
  business_name: "Tienda ABC",
  contact_phone: "+52 33 1234 5678",
  order_id: "12345",
  order_total: "$1,500.00",
  order_date: "31/12/2024",
  delivery_date: "02/01/2025",
  cancel_reason: "Solicitado por cliente",
  amount_due: "$1,500.00",
  due_date: "05/01/2025",
  days_remaining: "5",
  overdue_days: "3",
  total_debt: "$3,000.00",
  amount_paid: "$1,500.00",
  payment_date: "31/12/2024",
  remaining_balance: "$0.00",
  promotion_name: "Navidad 2024",
  discount_percent: "15%",
  valid_until: "15/01/2025",
  // Supplier order variables
  supplier_name: "Proveedor ABC",
  purchase_order_id: "5001",
  purchase_order_total: "$15,000.00",
  purchase_order_date: "03/01/2025",
  shipping_carrier: "FedEx",
  shipping_tracking: "123456789",
  delivery_estimate: "05/01/2025",
};

// Computed
const filteredTemplates = computed(() => {
  const categoryTypes = {
    orders: [
      "order_created",
      "order_confirmed",
      "order_shipped",
      "order_delivered",
      "order_cancelled",
    ],
    purchases: [
      "purchase_order_sent",
      "purchase_order_confirmed",
      "purchase_order_shipped",
      "purchase_order_delivered",
      "purchase_order_cancelled",
    ],
    payments: ["payment_due", "payment_overdue", "payment_received"],
    promotional: ["promotional"],
  };

  const types = categoryTypes[activeTab.value] || [];
  return templates.value.filter((t) => types.includes(t.event_type));
});

const previewContent = computed(() => {
  let content = templateForm.value.template_content;
  for (const [key, value] of Object.entries(SAMPLE_DATA)) {
    content = content.replace(new RegExp(`{{${key}}}`, "g"), value);
  }
  return content;
});

const isFormValid = computed(() => {
  return (
    templateForm.value.event_type &&
    templateForm.value.template_name &&
    templateForm.value.template_content
  );
});

// Methods
const getEventLabel = (eventType) => {
  return EVENT_CONFIG[eventType]?.label || eventType;
};

const getEventColor = (eventType) => {
  return EVENT_CONFIG[eventType]?.color || "grey";
};

const loadTemplates = async () => {
  loading.value = true;
  try {
    const response = await API.getWhatsAppTemplates();
    if (!response.error) {
      templates.value = response.data || [];
    }
  } catch (error) {
    console.error("Error loading templates:", error);
    toast.error("Error al cargar plantillas");
  } finally {
    loading.value = false;
  }
};

const loadEventTypes = async () => {
  try {
    const response = await API.getWhatsAppEventTypes();
    if (!response.error) {
      eventTypes.value = response.data || [];
    }
  } catch (error) {
    console.error("Error loading event types:", error);
  }
};

const loadVariables = async () => {
  if (!templateForm.value.event_type) {
    variables.value = [];
    return;
  }

  try {
    const response = await API.getWhatsAppVariables(
      templateForm.value.event_type
    );
    if (!response.error) {
      variables.value = response.data || [];
    }
  } catch (error) {
    console.error("Error loading variables:", error);
  }
};

const insertVariable = (variableName) => {
  templateForm.value.template_content += variableName;
};

const openNewTemplate = () => {
  editingTemplate.value = null;
  templateForm.value = {
    event_type: "",
    template_name: "",
    template_content: "",
  };
  variables.value = [];
  showEditor.value = true;
};

const editTemplate = async (template) => {
  editingTemplate.value = template;
  templateForm.value = {
    event_type: template.event_type,
    template_name: template.template_name,
    template_content: template.template_content,
  };
  await loadVariables();
  showEditor.value = true;
};

const saveTemplate = async () => {
  if (!isFormValid.value) return;

  savingTemplate.value = true;
  try {
    let response;
    if (editingTemplate.value) {
      response = await API.updateWhatsAppTemplate(
        editingTemplate.value.template_id,
        templateForm.value.template_name,
        templateForm.value.template_content
      );
    } else {
      response = await API.createWhatsAppTemplate(
        templateForm.value.event_type,
        templateForm.value.template_name,
        templateForm.value.template_content
      );
    }

    if (response.error) {
      toast.error(response.message_client || "Error al guardar");
    } else {
      toast.success("Plantilla guardada");
      showEditor.value = false;
      await loadTemplates();
    }
  } catch (error) {
    console.error("Error saving template:", error);
    toast.error("Error al guardar la plantilla");
  } finally {
    savingTemplate.value = false;
  }
};

const toggleTemplate = async (template, enabled) => {
  try {
    const response = await API.toggleWhatsAppTemplate(
      template.template_id,
      enabled
    );
    if (response.error) {
      toast.error(response.message_client || "Error al cambiar estado");
    } else {
      template.is_enabled = enabled ? 1 : 0;
    }
  } catch (error) {
    console.error("Error toggling template:", error);
    toast.error("Error al cambiar estado");
  }
};

const previewTemplate = (template) => {
  let content = template.template_content;
  for (const [key, value] of Object.entries(SAMPLE_DATA)) {
    content = content.replace(new RegExp(`{{${key}}}`, "g"), value);
  }
  previewModalContent.value = content;
  showPreview.value = true;
};

const confirmDelete = (template) => {
  templateToDelete.value = template;
  showDeleteConfirm.value = true;
};

const deleteTemplate = async () => {
  if (!templateToDelete.value) return;

  deleting.value = true;
  try {
    const response = await API.deleteWhatsAppTemplate(
      templateToDelete.value.template_id
    );
    if (response.error) {
      toast.error(response.message_client || "Error al eliminar");
    } else {
      toast.success("Plantilla eliminada");
      showDeleteConfirm.value = false;
      await loadTemplates();
    }
  } catch (error) {
    console.error("Error deleting template:", error);
    toast.error("Error al eliminar la plantilla");
  } finally {
    deleting.value = false;
  }
};

// Watch for tab changes to reload templates (optional - already using computed filter)
watch(activeTab, () => {
  // Templates are already filtered by computed property
});

onMounted(() => {
  loadTemplates();
  loadEventTypes();
});
</script>

<style scoped>
.variables-section {
  margin-top: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 4px;
}

.variables-section label {
  display: block;
  font-weight: bold;
  margin-bottom: 10px;
}

.variable-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.variable-chips .ui.label {
  cursor: pointer;
  transition: all 0.2s;
}

.variable-chips .ui.label:hover {
  background-color: #2185d0;
  color: white;
}

.variable-hint {
  display: block;
  margin-top: 10px;
  color: #888;
}

.preview-section {
  margin-top: 20px;
}

.preview-section label {
  display: block;
  font-weight: bold;
  margin-bottom: 10px;
}

.preview-box {
  background: #e8f5e9 !important;
  border-left: 4px solid #4caf50;
}

.preview-box pre {
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: inherit;
}

.ui.table .ui.button {
  margin-right: 4px;
}
</style>
